import React, { useState, useEffect, Fragment } from 'react'
import { Link } from 'react-router-dom';

const CardSpeaker = ({data,setActualizar}) => {
    const [speaker, setSpeaker] = useState({})
    useEffect(() => {
      setSpeaker(data)
    }, [data]);

    function eliminarSpeaker(){
        fetch('/rt_publications', {
            method: 'DELETE',
            body: JSON.stringify({id: data.ID_PUB}),
            headers: {'Content-Type': 'application/json'}
        })
        .then(res => res.json())
        .then(res => {
            setActualizar(true);
        })
        .catch(err => console.log('Error: '+err))
    }

    function ocultarMostrarSpeaker(){
        fetch('/rt_publications', {
            method: 'SUBSCRIBE',
            body: JSON.stringify({id: data.ID_PUB}),
            headers: {'Content-Type': 'application/json'}
        })
        .then(res => res.json())
        .then(res => {
            console.log(res);
            setActualizar(true);
        })
        .catch(err => console.log('Error: '+err))
    }

    function formatoDinero(valor) {
        valor = valor ? parseFloat(valor).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : '0.00';
        return valor;
    }

    return (
    <Fragment>
        <div className="col-md-6 mb-4">
            <div className="cardSpeaker">
                <div className="cardBody">
                    <p className="cardBlockInf"><span className="cardLabel">Name:</span> {speaker.NAME_PUB}</p>
                    <p className="cardBlockInf"><span className="cardLabel">Price:</span> ${formatoDinero(speaker.PRICE_PUB)}</p>
                    <p className="cardBlockInf textOverflow"><span className="cardLabel">Information:</span> {speaker.INFORMATION_PUB}</p>
                    <p className="cardBlockInf }"><span className="cardLabel">Picture:</span> {speaker.IMAGE_PUB}</p>
                    {/* <p><strong>Order: </strong> 1</p> */}
                </div>
                <div className="cardFooter buttonsTicket">
                    <Link to={`/publication-edit/`+speaker.ID_PUB}><button className="btnTicket edit"><i className="fa-regular fa-pen-to-square"></i> Edit</button></Link>
                    <button className="btnTicket delete" onClick={eliminarSpeaker}><i className="fa-regular fa-trash-can"></i> Delete</button>
                    {
                        speaker.IS_VISIBLE_PUB ?
                        <button className="btnTicket hide" onClick={ocultarMostrarSpeaker}><i className="fa-regular fa-eye-slash"></i> Hide</button>
                        :
                        <button className="btnTicket unhide" onClick={ocultarMostrarSpeaker}><i className="fa-regular fa-eye"></i> Unhide</button>
                    }
                </div>
            </div>
        </div>
    </Fragment>
    );
}
 
export default CardSpeaker;